import * as React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'
import { useConnectModal } from '../../hooks/walletModal'
import { useMediaQuery } from '@material-ui/core'
import { AccountBalanceWallet } from '@material-ui/icons'
import useAuth from '../../hooks/auth'
import router from 'next/router'
import log from '../../events/log'
import { ClickConnectWalletEvent } from '../../events/account_events'

const SignInButton = ({
  buttonText = 'Connect Wallet',
  showIconOnMobile = true,
}: {
  buttonText?: string
  showIconOnMobile?: boolean
}): JSX.Element => {
  const [signInHover, setSignInHover] = React.useState(false)
  const setVisible = useConnectModal()
  const isMobile = useMediaQuery('(max-width: 62em)')
  const { isConnected, signIn } = useAuth()

  const signInHoverState = useSpring({
    boxShadow: signInHover ? '0px 5px 25px rgba(255,255,255,0.2)' : '0px 0px 0px rgba(0,0,0,0)',
    transform: signInHover ? `translate3d(0,-2%,0)` : `translate3d(0,0%,0)`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  const ButtonComponent = showIconOnMobile ? ResponsiveButton : Button

  return (
    <ButtonComponent
      onMouseEnter={() => setSignInHover(true)}
      onMouseLeave={() => setSignInHover(false)}
      style={signInHoverState}
      onClick={() => {
        log(new ClickConnectWalletEvent(router.pathname))

        if (isConnected) {
          signIn()
        } else {
          setVisible(true)
        }
      }}
      showIconOnMobile={showIconOnMobile}
    >
      {isMobile && showIconOnMobile ? <AccountBalanceWallet htmlColor="black" /> : buttonText}
    </ButtonComponent>
  )
}

export default SignInButton

const ResponsiveButton = styled(animated.div)<{ showIconOnMobile: boolean }>`
  background: white;
  color: black;
  font-weight: 700;
  text-align: center;
  border-color: #ffffff;
  cursor: pointer;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  // mobile
  @media (max-width: 62em) {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    font-size: 15px;
  }

  @media (min-width: 62em) {
    margin-left: 15px;
    margin-right: 25px;
    padding: 8px 20px;
    border-radius: 10px;
    font-size: 17px;
  }
`

const Button = styled(animated.div)<{ showIconOnMobile: boolean }>`
  background: white;
  color: black;
  font-weight: 700;
  text-align: center;
  border-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
  padding: 8px 20px;
  border-radius: 10px;
  font-size: 17px;
`
